import { Card, Text, ThemeIcon, SimpleGrid } from "@mantine/core";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { SprintUser } from "../../bitmaker/schemas/Sprints/SprintUser";
import { SprintTimeOffUser } from "../../bitmaker/schemas/Sprints/SprintTimeOffUser";

function getWeekdays() {
  const start = startOfWeek(new Date(), { weekStartsOn: 2 });
  const end = endOfWeek(new Date(), { weekStartsOn: 2 });
  return eachDayOfInterval({ start, end })
    .filter((d) => d.getDay() >= 1 && d.getDay() <= 5)
    .map((d) => format(d, "yyyy-MM-dd"));
}

function getStatus(timeEntries: string[]) {
  const weekdays = getWeekdays();
  const today = format(new Date(), "yyyy-MM-dd");
  const entries = new Set(timeEntries);

  if (entries.has(today)) return "unavailable";
  if (weekdays.every((d) => !entries.has(d))) return "available";
  return "partial";
}

const statusColors: Record<string, string> = {
  available: "green",
  partial: "yellow",
  unavailable: "red",
};

type Props = {
  users: SprintUser[];
  ptoUsers: SprintTimeOffUser[];
};

export function UserAvailabilityTrafficLight({ users, ptoUsers }: Props) {
  const ptoById = new Map(ptoUsers.map((row) => [row.userId, row.daysOff]));

  return (
    <SimpleGrid cols={4} spacing="lg" mb="xl">
      {users.map((user) => {
        const entryDates = ptoById.get(user.userId) ?? [];
        const status = getStatus(entryDates);

        return (
          <Card shadow="sm" padding="md" radius="md" key={user.userId}>
            <Text fw={500}>{user.userDisplayName}</Text>
            <ThemeIcon
              size="sm"
              radius="xl"
              color={statusColors[status]}
              variant="filled"
              title={status}
            >
              &nbsp;
            </ThemeIcon>
          </Card>
        );
      })}
    </SimpleGrid>
  );
}
